module.exports = __webpack_public_path__ + "img/_02_b3ec6f2fb.png";